import {useQuery} from '@github-ui/react-query'
import {makeSelectDataFromQueryData} from '@github-ui/react-core/future/main-query'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {pullRequestsCommitsRoute} from '../../routes/commits-route'
import {usePullRequestBasePath} from '../../stores/layout-selectors'
import type {CommitsRoutePayload} from '../../routes/route-payload-types'

const selectCommits = makeSelectDataFromQueryData<CommitsRoutePayload>()

export function useOverviewCommits({enabled}: {enabled: boolean}) {
  const basePath = usePullRequestBasePath()
  const {isServer} = useRuntimeEnvironment()
  const queryKey = pullRequestsCommitsRoute.queries.mainQuery.makeQueryKey({pathname: `${basePath}/commits`})
  return useQuery({
    ...pullRequestsCommitsRoute.buildQueryOptions('mainQuery', queryKey),
    select: selectCommits,
    enabled: !isServer && enabled,
  })
}
